var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-divider',{style:({ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' })},[_vm._v("公共组件使用说明")]),_c('van-cell',{attrs:{"is-link":"","to":"/public/component/empty-demo"}},[_vm._v("Empty 缺省公共组件示例")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }